// メールテンプレート一覧
export const mail_template_columns = [
  {
    label: 'JA名',
    field: 'ja_name',
    sorc: 'asc',
    width: 80,
  },
  {
    label: 'タイトル',
    field: 'title',
    sorc: 'asc',
    width: 180,
  },
  {
    label: '種別',
    field: 'type',
    sorc: 'asc',
    width: 120,
  },
  {
    label: '開始日',
    field: 'start_date',
    sorc: 'asc',
    width: 80,
  },
  {
    label: '終了日',
    field: 'end_date',
    sorc: 'asc',
    width: 80,
  },
  {
    label: '詳細',
    field: 'button',
    sorc: 'asc',
    width: 60,
  },
];

// 同意文言一覧
export const clause_columns = [
  {
    label: 'JA名',
    field: 'ja_name',
    sorc: 'asc',
    width: 80,
  },
  {
    label: 'タイトル',
    field: 'title',
    sorc: 'asc',
    width: 180,
  },
  {
    label: '同意種類',
    field: 'type',
    sorc: 'asc',
    width: 120,
  },
  {
    label: '開始日',
    field: 'start_date',
    sorc: 'asc',
    width: 80,
  },
  {
    label: '終了日',
    field: 'end_date',
    sorc: 'asc',
    width: 80,
  },
  {
    label: '詳細',
    field: 'button',
    sorc: 'asc',
    width: 60,
  },
];

// 掲載書類一覧
export const displayed_document_columns = [
  {
    label: 'JA名',
    field: 'ja_name',
    sorc: 'asc',
    width: 10,
  },
  {
    label: '掲載書類',
    field: 'type',
    sorc: 'asc',
    width: 10,
  },
  {
    label: '画面表示名',
    field: 'display_name',
    sorc: 'asc',
    width: 120,
  },
  {
    label: 'ファイル名',
    field: 'file_name',
    sorc: 'asc',
    width: 80,
  },
  {
    label: '開始日',
    field: 'start_date',
    sorc: 'asc',
    width: 80,
  },
  {
    label: '終了日',
    field: 'end_date',
    sorc: 'asc',
    width: 60,
  },
  {
    label: '詳細',
    field: 'button',
    sorc: 'asc',
    width: 60,
  },
];

// 法人一覧
export const corporate_columns = [
  {
    label: '法人ID',
    field: 'id',
    sorc: 'asc',
    width: 80,
  },
  {
    label: '法人名',
    field: 'corporate_name',
    sorc: 'asc',
    width: 200,
  },
  {
    label: '住所',
    field: 'address',
    sorc: 'asc',
    width: 200,
  },
  {
    label: 'ステータス',
    field: 'corporate_status',
    sorc: 'asc',
    width: 110,
  },
  {
    label: '適用開始日',
    field: 'start_date',
    sorc: 'asc',
    width: 110,
  },
  {
    label: '適用終了日',
    field: 'end_date',
    sorc: 'asc',
    width: 110,
  },
  {
    label: 'JA名',
    field: 'group_code',
    sorc: 'asc',
    width: 130,
  },
  {
    label: '取引店',
    field: 'bank_branch_name',
    sorc: 'asc',
    width: 130,
  },
  {
    label: '詳細',
    field: 'button',
    sorc: 'asc',
    width: 100,
  },
];
